import axios from 'axios'
import { getAuthHeader } from './config'
import { API_URL } from '../constants/api'

const baseURL = '/enrollments'

const getEnrollments = async (courseId) => {
  const response = await axios.get(`${API_URL}/${courseId}${baseURL}`, getAuthHeader())

  return response.data
}

const updateEnrollment = async (courseId, enrollmentId, enrolledAs) => {
  const response = await axios.post(
    `${API_URL}/${courseId}${baseURL}`,
    {
      enrollmentId,
      enrolledAs
    },
    getAuthHeader()
  )
  return response.data
}

const enrollmentsService = {
  getEnrollments,
  updateEnrollment
}
export default enrollmentsService
